module.exports = __webpack_public_path__ + "static/media/man2.b0af8e7c.jpg";